export default {
  items: [],
  data: [],
  urlResolver: {},
  splash: true,
};
